import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaInformacionConfiguracionEditarVinculacionComponent {
  data
  status
  empresas = []
  agrupaciones = []

  constructor ($q, $catalogos) {
    this.$q = $q
    this.$catalogos = $catalogos
  }

  $onInit () {
    this.$q.all([
      this.$catalogos.get('empresas').then((data) => (this.empresas = data)),
      this.$catalogos.get('nominasAgrupacion').then((data) => (this.agrupaciones = data)),
    ])
  }
}

module.component('nominasNominaInformacionConfiguracionEditarVinculacion', {
  controller: NominasNominaInformacionConfiguracionEditarVinculacionComponent,
  template,
  bindings: {
    data: '<',
    status: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/configuracion/editar/vinculacion/component.js